module.exports = __webpack_public_path__ + "d664201f/img/link-icon.fa09ed66.svg";